module.exports = __webpack_public_path__ + "img/logo_dark.d6e7f14f.svg";